import React, { useState } from 'react';
import { Modal, Pressable, TouchableOpacity, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import MyAppText from './MyAppText';
import { WindowInformation } from '../services/window-information';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import Tooltip from './Tooltip';

interface DataTableHeaderProps {
    title: string;
    titleTooltip?: React.ReactNode;
    filterInput?: React.ReactNode;
    filter?: React.ReactNode;
    actions?: React.ReactNode;
    zIndex: number;
}

export default function DataTableHeader(props: DataTableHeaderProps) {
    const { styles, theme } = useStyles(stylesheet);
    const windowInfo = WindowInformation();
    const [openTableTooltipModal, setOpenTableTooltipModal] = useState<boolean>(false);

    return <View style={{ paddingBottom: 10, zIndex: props.zIndex }}>
        <View style={styles.container}>
            {!props.titleTooltip ?
                <MyAppText style={styles.headerText}>{props.title}</MyAppText>
                : windowInfo.isMobile
                    ? <View style={{ flexDirection: 'row', gap: 8, alignItems: 'center' }}>
                        <MyAppText style={styles.headerText}>{props.title}</MyAppText>
                        <TouchableOpacity onPress={() => setOpenTableTooltipModal(true)}>
                            <FontAwesomeIcon icon={faCircleInfo} fontSize={12} color={theme.colors.neutral[500]} />
                        </TouchableOpacity>
                    </View>
                    : <Tooltip
                        useSimpleBox
                        tooltipDirection='right'
                        tooltipContent={props.titleTooltip}
                        style={{ width: 500 }}
                    >
                        <View style={{ flexDirection: 'row', gap: 8, alignItems: 'center' }}>
                            <MyAppText style={styles.headerText}>{props.title}</MyAppText>
                            <FontAwesomeIcon icon={faCircleInfo} fontSize={12} color={theme.colors.neutral[500]} />
                        </View>
                    </Tooltip>
            }
            <View style={{ flex: 1 }} />
            {props.filterInput &&
                <View style={styles.inputWrapper}>
                    {props.filterInput}
                </View>
            }
            {props.filter &&
                <View style={styles.buttonsContainer}>
                    {props.filter}
                </View>
            }
            {props.actions &&
                <View style={styles.buttonsContainer}>
                    {props.actions}
                </View>
            }
        </View>
        <Modal
            visible={openTableTooltipModal}
            animationType='fade'
            onRequestClose={() => {
                setOpenTableTooltipModal(false);
            }}
            transparent={true}
            collapsable
        >
            <Pressable style={styles.modalContainer} onPressOut={() => setOpenTableTooltipModal(false)}>
                <View style={{ width: '95%' }}>
                    {props.titleTooltip}
                </View>
            </Pressable>
        </Modal>
    </View>;
}

const stylesheet = createStyleSheet(theme => ({
    container: {
        minHeight: 40,
        alignItems: 'center',
        flexDirection: 'row',
        gap: 10,
        flexWrap: 'wrap',
    },
    modalContainer: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#31313199',
        flex: 1,
    },
    headerText: {
        fontSize: 16,
        color: theme.colors.neutral['500'],
        fontWeight: '600',
    },
    inputWrapper: {
        flexGrow: 1,
        maxWidth: 290,
        minWidth: 290,
    },
    buttonsContainer: {
        flexDirection: 'row',
        alignItems: 'flex-end',
    },
}));
